module.exports = __webpack_public_path__ + "img/model-2.d176f48d.png";